import { InjectionToken, ValueProvider } from '@angular/core';

export const IMAGES_PATH_TOKEN = new InjectionToken<string>('IMAGES_PATH_TOKEN');

export const ImagesPathProvider: ValueProvider = {
  provide: IMAGES_PATH_TOKEN,
  useValue: './images',
};
